// @ts-nocheck

import { createContext } from 'react';

type MultiviewMatchContextProps = {
  matchId?: number;
};

export const MultiviewMatchContext = createContext<MultiviewMatchContextProps>({});
